(function () {
  function createSwiper(swiperEl, opts) {
    if (!swiperEl || !window.Swiper) return null;

    const container = swiperEl.closest(".custom-layout-a") || swiperEl.parentElement;
    const paginationEl =
      container?.querySelector("[data-swiper-pagination]") ||
      container?.querySelector(".swiper-pagination");

    return new Swiper(swiperEl, {
      ...opts,
      pagination: paginationEl ? { el: paginationEl, clickable: true } : undefined,
    });
  }

  function initOne(swiperEl) {
    if (!swiperEl || !window.Swiper) return;
    if (swiperEl.dataset.inited === "1") return;
    swiperEl.dataset.inited = "1";

    // ✅ 第一阶段：极速初始化（立即可见，几乎不占主线程）
    // - 不用 coverflow
    // - 不用 slidesPerView:"auto"
    // - 先不 loop（loop 初始化最重）
    const fast = createSwiper(swiperEl, {
      loop: false,
      speed: 300,
      grabCursor: true,
      centeredSlides: true,
      watchSlidesProgress: true,
      preloadImages: false,
      observer: true,
      observeParents: true,
      slidesPerView: 1.2,
      spaceBetween: 12,
      breakpoints: {
        700: { slidesPerView: 2.2, spaceBetween: 12, centeredSlides: true },
        1000: { slidesPerView: 3.2, spaceBetween: 16, centeredSlides: true },
      },
      lazy: { loadPrevNext: true, loadOnTransitionStart: false },
    });

    // ✅ 第二阶段：页面首屏渲染完成后升级（用户已看到内容，不会觉得“卡两秒才出现”）
    // 用 2 帧后再升级，避免阻塞首屏绘制
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        // 如果用户在这期间已经滑动了，就不升级，避免打断体验
        if (!fast || fast.touches?.isTouched) return;

        try {
          fast.destroy(true, true);
        } catch (e) {}

        // 升级为你原来的效果（coverflow + auto + loop）
        createSwiper(swiperEl, {
          loop: true,
          centeredSlides: true,
          grabCursor: true,
          speed: 700,
          slidesPerView: "auto",
          spaceBetween: 0,
          effect: "coverflow",
          coverflowEffect: {
            rotate: 0,
            stretch: 0,
            depth: 150,
            modifier: 2,
            slideShadows: false,
          },
          watchSlidesProgress: true,
          preloadImages: false,
          observer: true,
          observeParents: true,
          lazy: { loadPrevNext: true, loadOnTransitionStart: false },
        });
      });
    });
  }

  function initAll() {
    const nodes = document.querySelectorAll("[data-custom-swiper]");
    nodes.forEach(initOne);
  }

  // ✅ 立即初始化（不要 requestIdleCallback，不要 IO）
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  // Shopify 编辑器兼容
  document.addEventListener("shopify:section:load", initAll);
})();